import { lazy } from 'react';
import AuthRoles from '@/app/auth/authRoles';

const ResetPasswordPage = lazy(() => import('./ResetPasswordPage'));

const ResetPasswordConfig = {
  settings: {
    layout: {
      config: {
        navbar: {
          display: false,
        },
        toolbar: {
          display: false,
        },
        footer: {
          display: false,
        },
        leftSidePanel: {
          display: false,
        },
        rightSidePanel: {
          display: false,
        },
      },
    },
  },
  auth: AuthRoles.AllUsers,
  routes: [
    {
      path: 'reset-password',
      element: <ResetPasswordPage />,
    },
  ],
};

export default ResetPasswordConfig;
